export const VAS_ROLES = {
  GROUND_DEPS: 'ROLE_VAS_ADD',
  SAM_KAM: 'ROLE_CLAIM_SAM_KAM',
  MASTER_USER: 'ROLE_VAS_MASTER_USER'
};

// Raw role membership checks
export const hasGroundDepsRole = (authorities = []) =>
  authorities.includes(VAS_ROLES.GROUND_DEPS);

export const isMasterUser = (authorities = []) =>
  authorities.includes(VAS_ROLES.MASTER_USER);

export const hasSamKamRole = (authorities = []) =>
  authorities.includes(VAS_ROLES.SAM_KAM);

export const getVasUserRole = (authorities = []) => {
  if (isMasterUser(authorities)) return VAS_ROLES.MASTER_USER;
  if (hasSamKamRole(authorities)) return VAS_ROLES.SAM_KAM;
  if (hasGroundDepsRole(authorities)) return VAS_ROLES.GROUND_DEPS;
  return null;
};

export const isSamKam = (authorities = []) =>
  getVasUserRole(authorities) === VAS_ROLES.SAM_KAM;

export const isEffectiveGroundDeps = (authorities = []) =>
  getVasUserRole(authorities) === VAS_ROLES.GROUND_DEPS;

export const isGroundDeps = isEffectiveGroundDeps;
